export var ROUTE_PREFIX_CATEGORIES = 'categories';
export var ROUTE_PREFIX_HASHTAGS = 'hashtags';
export var ROUTE_PREFIX_ARCHIVE = 'archive';
export var ROUTE_PREFIX_TAGS = 'tags';
